module.exports = __webpack_public_path__ + "static/frontendisti-cd9bbcf5d1b0032b06ee800b0e0685e7.jpg";